import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['deselectButton']

  displayClosePicto() {
    this.deselectButtonTarget.classList.remove('hidden')
  }

  hideClosePicto() {
    this.deselectButtonTarget.classList.add('hidden')
  }

  deselectCategory() {
    this.element.querySelectorAll('input[type=checkbox]').forEach(input => (input.checked = false))
  }
}
